import { useInfiniteListQuery as e } from "@maat/store-hooks";
import { listingsApi as t } from "@maat/api-main";
//#region src/listings/useListingSearchQuery.ts
var n = {
	search: (e) => [
		"listings",
		"search",
		e
	],
	byIds: (e) => [
		"listings",
		"by-ids",
		e
	],
	calendar: (e) => [
		"listings",
		"calendar",
		e
	],
	calendars: () => ["listings", "calendar"],
	workspaceHostBlocks: () => ["listings", "workspace-host-blocks"]
}, r = (r) => e({
	queryKey: n.search(r),
	fetchPage: (e) => t.searchListings({
		...r,
		page: String(e)
	}),
	key: "listings"
});
//#endregion
export { n as listingQueryKeys, r as useListingSearchQuery };
